var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 59,
    viewBox: "0 0 41 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7548 23.0771C32.9844 23.3295 40.4608 31.304 40.4608 41.0384C40.4608 50.7728 32.732 58.9997 23.25 58.9997C13.7679 58.9997 6.03906 50.9229 6.03906 41.0384V28.2479L9.04739 29.7009V41.0384C9.04739 49.2653 15.4188 55.9914 23.2431 55.9914C31.0675 55.9914 37.4389 49.2653 37.4389 41.0384C37.4389 32.8116 31.0675 26.0855 23.2431 26.0855L23.7479 23.0771H23.7548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.926 9.07955C21.1895 16.5014 17.1784 26.7884 17.1784 26.7884C17.1784 26.7884 6.24337 25.083 1.97987 17.7089C-2.28363 10.3347 1.67972 0 1.67972 0C1.67972 0 12.6693 1.7054 16.9328 9.07955H16.926Z",
    fill: "#B6FF36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.4589,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4cadcad5e9536df126205c2940e43dc6.svg";
export { ForwardRef as ReactComponent };